export const networkKeys = {
	ping: ['network', 'ping'] as const,
}
